import { config } from "zod";

// Zod probes `new Function` when it builds an object schema; the app's
// script-src CSP refuses eval, so the probe would only log a violation.
config({ jitless: true });
